import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { DiagnosisSection } from '../components/DiagnosisSection';
import { SystemSection } from '../components/SystemSection';
import { ResultsSection } from '../components/ResultsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { ContactForm } from '../components/ContactForm';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { StickyMobileCTA } from '../components/StickyMobileCTA';
export function LandingPage() {
  return <main className="min-h-screen bg-carbon w-full overflow-x-hidden pb-24 md:pb-0" data-id="element-377">
      <HeroSection data-id="element-378" />
      <TrustBar data-id="element-379" />
      <DiagnosisSection data-id="element-380" />
      <div id="sistema" data-id="element-381">
        <SystemSection data-id="element-382" />
      </div>
      <div id="resultados" data-id="element-383">
        <ResultsSection data-id="element-384" />
      </div>
      <TestimonialsSection data-id="element-385" />
      <GuaranteeSection data-id="element-386" />
      <FAQSection data-id="element-387" />
      <ContactForm data-id="element-388" />
      <FinalCTASection data-id="element-389" />
      <Footer data-id="element-390" />
      <StickyMobileCTA data-id="element-391" />
    </main>;
}